import { Typography } from "@mui/material"
import { styled } from "@mui/system"

export const Text = styled(Typography)((props) => ({
  display: "block",
  width: "fit-content",
  background: "linear-gradient(90deg, #FF0097 0%, #0069E6 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent"
}))